module.exports = __webpack_public_path__ + "media/barcelona musica/gothic_street-e10c3f6f.jpg";